import { render, staticRenderFns } from "./DecisionMemoryReviewCard.vue?vue&type=template&id=72e54174&scoped=true"
import script from "./DecisionMemoryReviewCard.vue?vue&type=script&lang=js"
export * from "./DecisionMemoryReviewCard.vue?vue&type=script&lang=js"
import style0 from "./DecisionMemoryReviewCard.vue?vue&type=style&index=0&id=72e54174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e54174",
  null
  
)

export default component.exports